import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query';
import { AdaptivePlannerPlan } from '@/lib/api/adaptive-planner/plan';
import { adaptivePlannerQueryKeys } from '@/lib/query-keys/adaptivePlanner';

export const getPlanByLoopIdQueryOptions = ({
  loopId,
  enabled,
}: {
  loopId: number;
  enabled?: boolean;
}) =>
  queryOptions({
    queryKey: adaptivePlannerQueryKeys.plans.byLoopId({ loopId }),
    queryFn: () => AdaptivePlannerPlan.getPlanByLoopId({ loopId }),
    enabled: enabled && !!loopId,
  });

export const useGetPlanByLoopIdQuery = ({
  loopId,
  enabled = true,
}: {
  loopId: number;
  enabled?: boolean;
}) => {
  return useQuery(getPlanByLoopIdQueryOptions({ loopId, enabled }));
};

export const useGetPlanByLoopIdSuspenseQuery = ({ loopId }: { loopId: number }) => {
  return useSuspenseQuery(getPlanByLoopIdQueryOptions({ loopId, enabled: !!loopId }));
};
